import Http from "@/commons/Http";

const path = 'api/stage';

const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

const escapeHtml = (text) => {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

const buildColorSwatchHtml = (color, label = '') => {
    const safeColor = HEX_COLOR_PATTERN.test(color) ? color : '#CCCCCC';
    const dot = `<span class="stage-color-dot" style="background-color:${safeColor};"></span>`;
    return `<span class="stage-color-swatch">${dot}${escapeHtml(label)}</span>`;
};

const contrastColor = (color) => {
    if(!HEX_COLOR_PATTERN.test(color)){
        return '#000000';
    }
    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#000000' : '#FFFFFF';
};

const buildColorTagHtml = (color, label = '') => {
    const safeColor = HEX_COLOR_PATTERN.test(color) ? color : '#CCCCCC';
    return `<span class="p-tag stage-color-tag" style="background-color:${safeColor};color:${contrastColor(safeColor)};">${escapeHtml(label)}</span>`;
};

export default {

    buildColorSwatchHtml,
    buildColorTagHtml,
    contrastColor,

    async getAll(){
        return Http.get(`${path}`);
    },

    async getAllActive(){
        return Http.get(`${path}/active`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "Stage"};
        return Http.post(`${path}/audit?sort=${sort || 's.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 's.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

}
